import React from 'react';

import {PRESCRIPTION_STATUS} from 'constants/success';

const defaultHeading = {
    heading: <>Now we need your prescription.</>,
    info: <>We can&apos;t ship out your contacts without it.</>,
};

/**
 * get content for header TYP CL
 */
export const getTitleContent = (
    prescriptionStatus: string,
    userName: string,
): {heading: React.ReactNode; info: React.ReactNode} => {
    const METHODS = {
        [PRESCRIPTION_STATUS.DEFAULT]: defaultHeading,
        [PRESCRIPTION_STATUS.EYE_EXAM]: {
            heading: <>We sent the online vision test link to your inbox.</>,
            info: (
                <>We&apos;ll update your order as soon as we receive your renewed prescription.</>
            ),
        },
        [PRESCRIPTION_STATUS.FILL]: {
            heading: <>Now we need to confirm your prescription.</>,
            info: (
                <>
                    We can&apos;t ship out your order without verifying the prescription with
                    <br />
                    your eye doctor.
                </>
            ),
        },
        [PRESCRIPTION_STATUS.FILL_SUCCESS]: {
            heading: (
                <>
                    Thanks, {userName}. Now we&apos;ll verify the
                    <br />
                    prescription with your eye doctor.
                </>
            ),
            info: (
                <>
                    Once our team verifies your prescription (takes up to 1 business day),
                    <br />
                    your order will be on its way.
                </>
            ),
        },
        [PRESCRIPTION_STATUS.MISSING_ITEM_PRESCRIPTION]: {
            heading: <>Some items in your order require additional details.</>,
            info: <>We cannot ship out your order without them.</>,
        },
        [PRESCRIPTION_STATUS.MIXED_ITEMS_SUCCESS]: {
            heading: <>Thank you, {userName}, your order has been submitted.</>,
            info: <>Once we have all the missing details, we will ship out your order.</>,
        },
        [PRESCRIPTION_STATUS.SKIP]: {
            heading: <>Now we need your prescription.</>,
            info: <>We can&apos;t ship out your contacts without it.</>,
        },
        [PRESCRIPTION_STATUS.UPLOAD]: {
            heading: (
                <>
                    Thank you, {userName}. We&apos;ll verify the
                    <br />
                    prescription with your eye doctor.
                </>
            ),
            info: (
                <>
                    This can take up to 1 business day. Once verified, we&apos;ll ship out
                    <br />
                    your order ASAP.
                </>
            ),
        },
        [PRESCRIPTION_STATUS.UPLOAD_SUCCESS]: {
            heading: <>Awesome! Thank you {userName}, we&apos;re on it.</>,
            info: (
                <>
                    Once our team verifies your prescription (takes up to 1 business day),
                    <br />
                    your order will be on its way.
                </>
            ),
        },
        [PRESCRIPTION_STATUS.VISIBLY]: {
            heading: <>You&apos;ve already started your vision test.</>,
            info: (
                <>We&apos;ll update your order as soon as we receive your renewed prescription.</>
            ),
        },
        [PRESCRIPTION_STATUS.VISTA]: {
            heading: <>Now we need to confirm your prescription.</>,
            info: <>We can&apos;t ship out your order without verifying the prescription.</>,
        },
    };

    return METHODS[prescriptionStatus] || defaultHeading;
};
